import React from 'react';
import {
  BooleanField,
  FunctionField,
  NumberField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
} from 'react-admin';

import { App } from '../../../graphql/types';

export const NotificationOptionShow: React.FC = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Details">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />
        <FunctionField
          source="app"
          label="App"
          render={(record: { app: App }) =>
            record.app === App.Heart ? 'Fit' : 'Perform'
          }
        />
        <NumberField source="position" />
        <BooleanField source="visible" />
        <TextField source="value" />
        <TextField source="featureFlag" label="Feature Flag" />
        <NumberField source="iterableId" label="Iterable ID" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
